import BaseEntity from '../base/BaseEntity.model';

export default class TipoTramiteNota extends BaseEntity{
    constructor(
        public descripcion?: string,
        public tipoTramiteId?: number
    ) {
        super();
    }
}